import createReactComponent from '../createReactComponent';
export default createReactComponent('map-share', 'IconMapShare', [
  ['path', { d: 'M13 19l-4 -2l-6 3v-13l6 -3l6 3l6 -3v9', key: 'svg-0' }],
  ['path', { d: 'M9 4v13', key: 'svg-1' }],
  ['path', { d: 'M15 7v6.5', key: 'svg-2' }],
  ['path', { d: 'M16 22l5 -5', key: 'svg-3' }],
  ['path', { d: 'M21 21.5v-4.5h-4.5', key: 'svg-4' }],
]);
